import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackAccordianTitle]',
    standalone: false
})
export class AccordianTitleDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);


}
